import { XMarkIcon } from "@heroicons/react/20/solid";
import { ModalConfig, useModalStore } from "@/stores/use-modal-store";

const SECTIONS = [
  {
    title: "Attention scores per scene",
    body: "We break your video into scenes and calculate an average Attention score for each one. Scoring by scene - rather than frame by frame - keeps the results fast to process and easy to read, while still showing how attention shifts across the video.",
  },
  {
    title: "Scene averages",
    body: "Each score is an average across the whole scene. If a scene contains both high- and low-attention moments, the graph shows the average of the two, so a scene's peaks and dips may be smoothed out in its single score.",
  },
  {
    title: "Scenes connected by line graph",
    body: "We connect the scenes into a continuous line so you can spot patterns at a glance and quickly see which scenes are underperforming.",
  },
];

// The video in-depth view is always rendered on a fixed dark background regardless of the app
// theme, so this modal matches that instead of the theme-aware daisyUI modal-box.
export const VIDEO_GRAPH_EXPLAINED_MODAL_CONFIG: ModalConfig = { className: "w-full max-w-[600px]" };

/**
 * VideoGraphExplainedModal component
 *
 * Explains how the attention graph's per-scene scores are calculated and connected.
 */
export const VideoGraphExplainedModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-4 -m-6 p-6 rounded-2xl bg-[#1d232a]">
      {/* Header */}
      <div className="flex items-center gap-1">
        <h2 className="flex-1 text-white font-semibold text-lg">About this graph</h2>
        <button type="button" onClick={close} aria-label="Close" className="cursor-pointer">
          <XMarkIcon className="size-5 text-white" />
        </button>
      </div>

      <div className="flex flex-col gap-4">
        {SECTIONS.map((section) => (
          <div key={section.title} className="text-white/70 text-sm">
            <p className="font-bold text-white">{section.title}</p>
            <p>{section.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
